<template>
  <section class="primaryInfo">
    <a
      name="home"
      style=" position: relative;top: -420px;display: block;height: 0;overflow: hidden;"
    ></a>
    <section class="information">
      <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>
      <section class="innerBox">
        <div class="leftMenu">
          <li
            @click="gotoHandle(leftItem.anchorId)"
            :class="[
              'menu-item',
              isActive === leftItem.anchorId ? 'menu-item--active' : '',
            ]"
            v-for="(leftItem, idx) in leftMenus"
            :key="idx"
          >
            {{ leftItem.title }}
          </li>
        </div>
        <div class="info">
          <h1>ToTokGame Terms of Use</h1>
          <h3>Last updated: April 17, 2020</h3>
          <p>
            <strong>
              Please read these Terms of Use carefully
            </strong>
          </p>
          <br />
          <p>
            The ToTokGame Center is hosted by ToTok Technology Limited, and the games 
            (the "<strong>Games</strong>") provided by Amusement Planet Pte Ltd, (together "<strong>ToTokGame</strong>", 
            "<strong>we</strong>", "<strong>us</strong>" or "<strong>our</strong>"). These terms of use (the "<strong>Terms of Use</strong>") form a binding 
            contract between you ("<strong>you</strong>" or "<strong>your</strong>" being the device owner and/or user of the 
            ToTokGame Center Services) and ToTokGame which governs your use of Games made 
            available through the ToTokGame Center (the "<strong>ToTokGame Center Services</strong>"). By 
            accessing the ToTokGame Center Services via the instant messaging application 
            ToTok ("<strong>ToTok</strong>" or the "<strong>App</strong>") and using the ToTokGame Center Services, or any of
             their features, you are acknowledging that these Terms of Use are legally binding 
             and are agreeing to comply with these Terms of Use.
          </p>
          <p>
            ToTokGame Center Services are only available to users of the
            messaging application ToTok, and you hereby acknowledge that you are
            a user of ToTok and have a valid account with ToTok. Your use of
            ToTok will be governed by the ToTok Terms of Use accessible at
            <a href="https://totok.ai/terms">https://totok.ai/terms</a>. Any
            references to the "<strong>App</strong>" within these Terms of Use
            will be read as ToTok and/or the ToTokGame Center Services area of
            ToTok. The following provisions from the
            <a href="https://totok.ai/terms">ToTok Terms of Use</a> shall apply
            to the ToTokGame Center Services: clauses 1 (Contact); 2 (Language);
            5 (General Conditions); 6 (Acceptable Use); 9 (Updates); 10
            (Support); 11 (Disclaimer); 12 (Our Liability); 13 (Your Liability);
            14 (Termination); 15 (General); and 16 (Governing Law). When
            incorporating such clauses into these Terms of Use, any reference in
            any such clause to "we", "us", "our" or "ToTok" shall be construed
            as referring to "ToTokGame", and any reference to "Services" shall
            be construed as referring to the "ToTokGame Center Services" and/or
            "Games", as applicable, each term as defined in these Terms of Use.
          </p>
          <p>
            We reserve the right to update these Terms of Use at any time and
            will do so by updating the Terms of Use accessible in the App. You
            will also be notified of any material changes to these Terms of Use
            via email, the App, or through another medium of using the ToTokGame
            Center Services. Your continued use of the ToTokGame Center Services
            and Games will be deemed acceptance of the updated Terms of Use. If
            you do not accept the updated Terms of Use, you are no longer
            permitted to use the ToTokGame Center Services and the Games, and
            should cease using the ToTokGame Center Services and the Games
            immediately.
          </p>
          <p>
            Providing you with the ToTokGame Center Services and Games requires
            that we collect, store, use, share and otherwise process your
            personal data. To learn what kinds of personal data we process along
            with why, how and where we process it, please read our
            <a href="https://totok.ai/totok-game-privacy"
              >ToTokGame Privacy Policy</a
            >. It will also provide useful information about your rights in
            relation to your personal data and how you can exercise such rights.
          </p>
          <h2>
            1. Account Registration
          </h2>
          <p>
            When you access our ToTokGame Center Services for the first time,
            you will be asked to create an account. You will not be able to
            fully access the ToTokGame Center Services and Games without
            creating and maintaining a valid account. Creating your account will
            use certain of the details and information you have already provided
            us when creating your ToTok account – further information regarding
            this information can be read in our
            <a href="https://totok.ai/privacy">Privacy Policy</a>.
          </p>
          <h2>
            2. Intellectual Property And Licences
          </h2>
          <p>
            2.1 Throughout our relationship with you, we retain ownership and/or
            control, as appropriate, of the ToTokGame Center Services, the Games
            and all intellectual property rights therein, including all
            copyrights, trademarks, domains, logos, trade secrets, patents, and
            other intellectual property rights that have existed, do, may or
            will exist in the future ("<strong>Intellectual Property</strong>").
            You may not use our Intellectual Property unless permitted under
            these Terms of Use or with our express written consent (which you
            can seek by contacting us using the contact details above)
          </p>
          <p>
            2.2 In order for us to provide our ToTokGame Center Services and
            Games, we grant to you a non-exclusive, non-transferable, revocable,
            limited licence to use our ToTokGame Center Services and Games for
            your personal and non-commercial use, solely for the purpose for
            which they were created, subject to and in accordance with these
            Terms of Use. Subject to the licence granted in clause 5.4 of these
            Terms of Use relating to Virtual Money and Virtual Goods, no other
            licences or rights are granted to you by implication or otherwise.
          </p>
          <p>
            2.3 You acknowledge and agree that all title, ownership rights, and
            Intellectual Property connected with the ToTokGame Center Services
            and the Games (including but not limited to, Virtual Money and
            Virtual Goods, and any other contents or features incorporated into
            the Game(s) such as derivative works, titles, computer codes,
            audiovisual effects, themes, characters, character names, stories,
            dialog, settings, artwork, sounds effects, musical works, and any
            related documentation) are owned by us or our licensors.
          </p>
          <p>
            2.4 You acknowledge and agree that you have no ownership or other
            proprietary interest or right in the content generated by you when
            using the Games, including but not limited to, any, images, sounds,
            and all materials and information you or other users create, upload
            or transmit while using our ToTokGame Center Services or any other
            contents that is based on or created by using our Games ("<strong
              >Game Content</strong
            >").
          </p>
          <p>
            2.5 Excluding Game Content, throughout our relationship with you,
            you retain ownership of the details, information or other data you
            submit for your ToTokGame account or through the use of our
            ToTokGame Center Services and Games. You also have the right to
            grant the rights and licences in these Terms of Use as further
            detailed below.
          </p>
          <p>
            2.6 In order for us to provide our ToTokGame Center Services and
            Games to you to the best of our ability, you grant ToTokGame a
            worldwide, royalty-free, sublicensable, and transferable license to
            use, reproduce, distribute, create derivative works of, and display
            the information (including any content) that you upload, store,
            send, or receive on or through the use of the ToTokGame Center
            Services and Games. We will only use such rights for the limited
            purpose of providing our ToTokGame Center Services and Games which
            includes, for example, us displaying your profile image within the
            Game you are playing.
          </p>
          <h2>
            3. Access And Updates
          </h2>
          <p>
            3.1 You acknowledge and understand that we reserve the right to
            withdraw, modify, update, replace or otherwise make changes to our
            ToTokGame Center Services and our Games (in whole or in part) at any
            time, without any liability to you.
          </p>
          <p>
            3.2 You acknowledge and understand that there may be times when our
            ToTokGame Center Services, Games or any parts of our ToTokGame
            Center Services or Games are not available for technical or
            maintenance related reasons, whether on a scheduled or unscheduled
            basis.
          </p>
          <h2>4. Age Guidelines</h2>
          <p>
            4.1 We may suggest a Game is only suitable for a user above a
            certain age. You agree to comply with any such guidelines we
            suggest, including with respect to any other person accessing Games
            using your account.
          </p>
          <p>
            4.2 We may suggest a suitable age guideline for a Game that is lower
            than the restriction stated in clause 5 of the ToTok Terms of Use.
            You acknowledge that, as the account holder of ToTok and ToTok Game,
            you are responsible for determining whether a minor is permitted to
            access any Game. You acknowledge that you are solely responsible and
            liable for allowing a minor to access and use a Game, including in
            relation to any interactions the minor may have in the Game or
            charges the minor may occur, and that neither we, nor any of our
            group companies, shall be held liable for any losses of any nature
            howsoever caused in respect of the minor accessing and/or using the
            Game.
          </p>
          <h2>5. Virtual Money And Virtual Goods</h2>
          <p>
            5.1 Our Games may offer the option to purchase virtual currencies
            ("<strong>Virtual Money</strong>") and virtual items ("<strong
              >Virtual Goods</strong
            >"). Subject to clause 5.2, you may purchase Virtual Money and/or
            Virtual Goods in exchange for legal currency or other credits if:
          </p>
          <ul>
            <li>
              you are the age of majority in the country of your residence and
              have your own bank account or ToTokPay account which you will use
              to make such purchase;
            </li>
            <li>
              you are the age of majority in the country of your residence, but
              do not have your own bank account or ToTokPay account, and have
              the express consent of the relevant account-holder of the bank
              account or ToTok account you are using to make the purchase. You
              are responsible for seeking or providing such consent and if we
              believe necessary, we may seek confirmation from the
              account-holder that such consent was granted; or
            </li>
            <li>
              you are under the age of majority in the country of your
              residence, either do or do not have a bank account or ToTokPay
              account you can make the purchase using, and have the express
              consent of a parent or legal guardian to make the purchase. You
              are responsible for seeking or providing such consent and if we
              believe necessary, we may seek confirmation from the parent or
              legal guardian that such consent was granted.
            </li>
          </ul>
          <p>5.2 You may only purchase Virtual Money or Virtual Goods from:</p>
          <ul>
            <li>
              the app store you use to purchase applications, using the bank
              account information linked to said app store; or
            </li>
            <li>us using a valid ToTokPay account registered to you,</li>
          </ul>
          <p>
            and you hereby agree not to purchase Virtual Money or Virtual Goods
            from any other third party. You acknowledge that any purchase of
            Virtual Money or Virtual Goods you make from an app store in
            accordance with this clause 5.2 will expressly be covered by the
            applicable terms and conditions provided by the app store and that
            we are in no way responsible or liable for such purchase, or any
            losses caused thereto. We encourage you to read such terms and
            conditions to ensure you fully understand your rights and
            obligations with respect to any purchase from an app store.
          </p>
          <p>
            5.3 You acknowledge and agree that Virtual Goods and Virtual Money
            have no monetary value and do not constitute property of any type or
            actual currency of any kind. Virtual Goods and Virtual Money only
            exist within our ToTokGame Center Services and specifically within
            the Game in which they were purchased, and can never be exchanged
            for real money, real goods or real services from us, any of our
            group companies, or any third party. You acknowledge and agree that
            you will not attempt to sell or exchange any Virtual Goods or
            Virtual Money for real money, real goods or real services from us,
            any of our group companies, or any third party.
          </p>
          <p>
            5.4 From the time of purchase, we grant to you a non-exclusive,
            non-transferable, revocable, limited licence to use Virtual Money
            and/or Virtual Goods within the Game in which it was purchased for
            the purpose for which they were offered in the Game.
          </p>
          <p>
            5.5 We reserve the right at any time to offer, modify, control,
            regulate, and/or remove any Virtual Goods and/or Virtual Money, or
            the use or provision thereof, within or from a Game, without any
            liability to you.
          </p>
          <p>
            5.6 We reserve the right at any time to remove any Virtual Goods
            and/or Virtual Money from your ToTokGame account should we believe
            you have used any Virtual Goods and/or Virtual Money contrary to
            these Terms of Use or applicable law, or otherwise breached these
            Terms of Use or applicable law.
          </p>
          <p>
            5.7 Unless the purchase was made due to a breach by us of these
            Terms of Use, you acknowledge and agree that all purchases of
            Virtual Money and Virtual Goods are final and we will not refund any
            transactions once the purchase is complete.
          </p>
          <p>
            5.8 If these Terms of Use and/or your access to the ToTokGame Center
            Services and Games is suspended or terminated for any reason, you
            acknowledge that we are not responsible for providing a refund or
            other compensation for any Virtual Money or Virtual Goods purchased
            before termination or suspension.
          </p>
        </div>
        <!-- <div class="cp">All rights reserved, 2020 © Totok Pte. Ltd.</div> -->
      </section>
    </section>
    <Footer></Footer>
    <FootBanner></FootBanner>
  </section>
</template>

<script>
import NavCrumbs from "@/components/NavCrumbs.vue";
import Footer from "@/components/Footer.vue";
import FootBanner from "@/components/FootBanner.vue";
export default {
  name: "TermsGame",
  metaInfo() {
    return {
      title: "Terms of Use - ToTok Game",
      meta: [
        { property: "og:title", content: "Terms of Use - ToTok Game" },
        {
          property: "og:description",
          content:
            "ToTok provide you service with serious procedures and commitment",
        },
        { property: "og:url", content: "https://totok.ai/totok-game-terms" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  components: {
    NavCrumbs,
    Footer,
    FootBanner,
  },
  data() {
    return {
      crumbProp: {
        label: "Privacy & Terms",
        type: "simple",
      },
      archivedVersionLabel: "(archived versions)",
      showinfo: false,
      isActive: "totok-game-terms",
      leftMenus: [
        {
          title: "Terms of Use",
          anchorId: "totok-game-terms",
        },
        {
          title: "Privacy Policy",
          anchorId: "totok-game-privacy",
        },
      ],
    };
  },
  computed: {
    info() {
      return [];
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
  methods: {
    gotoHandle(palice) {
      this.isActive = palice;
      this.$router.push(palice);
    },
  },
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
    .innerBox {
        padding-bottom:60px;
    }
    .primaryInfo {
        padding: 0.8rem 0px;
        background: #fafafa;
        height: 82vh;

        .leftMenu {
            display none
        }

        div {
            margin-left: 20px;
            margin-right: 20px;
        }

        .info {

        div {
            margin-left: 20px;
            margin-right: 20px;
        }

            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 40px;
                margin: 0px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            h6 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-style: italic;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
        }
    }

    .cp {
        height: 3.5rem;
        font-size: 13px;
        color: #808080;
        line-height: 3.5rem;
        text-align: center;
    }
}

@media only screen and (min-width: 701px) {
    .primaryInfo {
        padding-top: 102px;
        width: 100vw;
        background: #fafafa;

        .information {
            margin: 0 auto;
            width: 800px;

            .innerBox {
                position relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;
                height: 83vh;
                overflow: auto;

                .leftMenu {
                    position: absolute;
                    left: 0px;
                    top: 39px;
                    display flex;
                    flex-direction column;
                    justify-content center;
                    align-items: center;
                    list-style none;

                    .menu-item {
                        color: #979797;
                        margin-top: 30px;
                        cursor pointer;
                        text-decoration none;
                        font-size: 15px;
                    }

                    .menu-item:nth-child(1) {
                        margin-top: 0px;
                    }

                    .menu-item--active {
                        color: #000;
                        border-bottom: 2px solid #4377f2;
                    }

                }
            }
        }

        .info {
            width: 620px;
            margin: 20px 0;
            margin-bottom:40px;

            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 20px;
                margin: 0px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            h6 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-style: italic;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
        }
    }

    .cp {
        height: 70px;
        font-size: 13px;
        color: #808080;
        line-height: 70px;
        text-align: center;
    }
}
</style>
